import React, { useState, useEffect } from "react";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { handleGetItemsWithParam } from "../../shared/controllers/blogController";
import { unwrapApiArray } from "../../shared/utils/apiResponse";

import "swiper/css";

interface Heading {
    category: string;
    title?: string;
    excerpt?: string;
}

interface TestimonialItem {
    title: string;
    image: string;
    excerpt: string;
}

interface TestimonialProps {
    headings: Heading[];
}

const Testimonial: React.FC<TestimonialProps> = ({ headings }) => {
    const [pageTitle, setPageTitle] = useState("Testimony");
    const [pageSubtitle, setPageSubtitle] = useState("Hear From Our Thriving Community");

    const [testimonials, setTestimonials] = useState<TestimonialItem[]>([]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState(true);

    const fetchTestimonials = async () => {
        const params = { type: "Testimonial" };
        try {
            const data = await handleGetItemsWithParam<TestimonialItem[]>(params);
            setTestimonials(unwrapApiArray<TestimonialItem>(data));
        } catch (error) {
            console.error("Error fetching testimonials:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTestimonials();
    }, []);

    const fallbackTestimonials: TestimonialItem[] = [
        {
            title: "Oluwaseun Adebayo",
            image: "testi1",
            excerpt:
                "As a Sunday league football captain, SACA has been a revelation. Gone are the days of scrambling to book pitches and chasing players for availability. Now, I can manage everything from fixture scheduling to player stats in one app. It's made running our team a breeze and lets us focus on what really matters - the beautiful game!",
        },
        {
            title: "Oluwaseun Adebayo",
            image: "testi2",
            excerpt:
                "As a Sunday league football captain, SACA has been a revelation. Gone are the days of scrambling to book pitches and chasing players for availability. Now, I can manage everything from fixture scheduling to player stats in one app. It's made running our team a breeze and lets us focus on what really matters - the beautiful game!",
        },
        {
            title: "Oluwaseun Adebayo",
            image: "testi3",
            excerpt:
                "As a Sunday league football captain, SACA has been a revelation. Gone are the days of scrambling to book pitches and chasing players for availability. Now, I can manage everything from fixture scheduling to player stats in one app. It's made running our team a breeze and lets us focus on what really matters - the beautiful game!",
        },
    ];

    useEffect(() => {
        const testimonialHeading = headings.find((heading) => heading.category === "Testimonials");
        if (testimonialHeading) {
            setPageTitle(testimonialHeading.title || "Testimony");
            setPageSubtitle(testimonialHeading.excerpt || "Hear From Our Thriving Community");
        }
    }, [headings]);

    const displayTestimonials = testimonials.length > 0 ? testimonials : fallbackTestimonials;

    return (
        <div className="flex flex-col items-center py-8 md:py-16 mt-8 md:mt-16 w-full lg px-4 md:px-14">
            <h3 className="text-center">{pageTitle}</h3>
            <h2 className="text-center mt-3">{pageSubtitle}</h2>

            <Swiper
                pagination={{
                    clickable: true,
                    el: ".model-pagination",
                }}
                modules={[Pagination]}
                breakpoints={{
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                }}
                className="mt-16 w-full"
            >
                {displayTestimonials.map((item, index) => (
                    <SwiperSlide key={index} className=" w-full">
                        <div className="w-full bg-[#F3F0E9] h-[400px] md:h-[420px] rounded-[20px]">
                            <div className="w-full p-4 md:p-8">
                                <p className="font-Manrope text-base h-[230px] overflow-y-auto pr-2 md:text-lg font-normal">
                                    {item.excerpt}
                                </p>
                                <div className="flex items-center space-x-3 mt-12 ">
                                    <span
                                        style={{
                                            backgroundImage: `url(${item.image})`,
                                            backgroundPosition: "center",
                                            backgroundSize: "cover",
                                        }}
                                        className="w-8 h-8 rounded-full bg-[#979797]"
                                    ></span>
                                    <p className="font-Manrope font-bold text-2xl text-black">
                                        {item.title}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}

                <div className="model-pagination flex justify-center w-full items-center space-x-[10px] mt-8"></div>
            </Swiper>
        </div>
    );
};

export default Testimonial;
